enum InitialHoldPurchaserTypes {
  PURCHASER = "purchaser",
  CHANNEL_PARTNER_OR_BUILDER = "channel partner or builder",
}
export default InitialHoldPurchaserTypes;
